import { type FC } from 'react';
import { ActiveBoundaryContainer } from '~/sidebar/sidebarApps/mapTools/boundary/activeBoundary/activeBoundary.container';
import { useBoundaryTerritoryGroupsGroupedByBoundaryGroupSelector } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.selectors';

type ActiveBoundariesComponentProps = {
  legendMode?: boolean;
};

export const ActiveBoundariesComponent: FC<ActiveBoundariesComponentProps> = ({ legendMode }) => {
  const boundaryTerritoryGroupsByBoundaryGroupId = useBoundaryTerritoryGroupsGroupedByBoundaryGroupSelector();

  return (
    <>
      {boundaryTerritoryGroupsByBoundaryGroupId
        .map(({ boundaryGroupId, boundaryTerritoryGroups }) => (
          <ActiveBoundaryContainer
            key={boundaryGroupId}
            boundaryGroupId={boundaryGroupId}
            boundaryTerritoryGroups={boundaryTerritoryGroups}
            legendMode={legendMode}
          />
        ))}
    </>
  );
};
